"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CIN = function CIN(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m298.163 300c81.502 0 128.169-53.169 128.169-101.503 0-57.828-64.495-98.497-133.498-98.497-55.329 0-93.662 32.664-114.671 57.5-28.662 34.167-44.496 38.497-44.496 38.497 22.171 19.507 32.664 29.332 43.004 40.505 28.991 31.326 52.993 63.497 121.491 63.497",
    fill: "#c6011f"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m296.672 286.338c-59.167 0-82.5-25.34-109.835-54.507-11.174-11.995-18.333-22.664-36.503-36.161l3.662 8.661c17.5 14.332 24.671 24.672 36.009 36.667 27.5 29.003 50.329 51.832 109.495 51.832 51.831 0 91.995-25.658 110.833-57.159l-2.829-6.667c-18.838 31.667-59.002 57.335-110.833 57.335"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m298.163 138.169c-57.829 0-80.493 38.333-80.493 56.831 0 10.669 3.168 20 8.333 28.004-3.498-6.502-4.332-16.338-4.332-22.676 0-18.498 21.832-55.493 78.498-55.493 34.002 0 59.659 15.668 68.333 29.331h42.829c-.833-1.503-2.664-6.667-2.664-6.667h-40.998c-8.498-13.662-35.505-29.331-69.507-29.331"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m186.837 231.831c27.335 29.167 50.668 54.507 109.835 54.507 51.832 0 91.995-25.668 110.833-57.171h-40.504c-19.003 14.331-42.171 25.997-71.667 25.997-27.171 0-55.669-11.326-69.331-32.16-5.34-8.004-8.333-17.335-8.333-28.004 0-18.497 22.664-56.831 80.668-56.831 33.991 0 60.998 15.668 69.495 29.331h40.833c-19.002-37.5-68.004-60-116.995-60-48.168 0-84.835 27.829-106.009 52.829-27.993 33.004-35.329 35.34-35.329 35.34 18.169 13.497 25.329 24.167 36.503 36.161",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m322.33 191.162h-9.167v-4.332h-13.498v8.839h4.507v-4.332h8.826l4.672 4.332h9.167v-12.007l-4.507-4.496z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m284.501 219.671 4.331 4.496h38.005v-11.831l-4.507-4.507v11.842z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m299.665 203.333v8.838h4.507v-4.342h11.162v-7.665l-4.496-4.495v7.664h-11.174z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m284.501 186.831 4.331 4.507h1.667v-4.507h-5.997z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m232.506 186.831 4.496 4.507h1.503v-4.507h-5.998z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m232.506 219.671 4.496 4.496h21.162v-7.5l-4.496-4.496v7.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m265.006 201.338 4.824 10.833h2.5l-2.829-6.338 6.831-5.669v-8.826l-4.495-4.507v8.839l-6.832 5.668z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m247.671 203.333v8.838h4.495v-4.507h5.998l-1.996-4.331z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m274.83 219.671h-11.491l4.332 4.496h11.667v-7.5l-4.507-4.496v7.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m262.671 191.338v-2.5l-2.336-2.007h-12.664v9.003h4.495v-4.496z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m299.665 186.831h13.498v4.332h9.167v-11.996h-37.829v7.664h5.997v25.34h-5.997v7.5h37.829v-11.842h-9.167v4.342h-13.498v-8.838h11.174v-7.664h-11.174v-8.839z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m274.83 212.171h-5l-4.66-11.009 6.667-5.493v-8.839l-9.167-7.664h-30.165v7.664h5.998v25.34h-5.998v7.5h21.162v-7.5h-6.162v-8.838h8.662l1.996 4.496 5.176 12.007h11.491v-7.665zm-22.665-16.338h-4.495v-8.838h12.664l2.336 2.007v5.164l-2.172 1.831h-8.333z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m332.001 186.831 4.331 4.507h1.667v-4.507h-5.997z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m360.663 191.338v-2.5l-2.324-2.007h-11.338v25.34h4.496v-20.833h9.167z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m369.666 212.171-9.002 7.5h-28.662l4.331 4.496h25.834l12.007-9.836v-22.993l-4.507-4.507v25.34z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m399.666 203.333h-11.502l-8.991-7.664 14.331 12.16h8.498v-2.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m415.499 207.829-4.496-4.496v8.662l-9.002 7.84h-11.502l-2.336-2.172v2.172h-8.991l4.331 4.495h9.167v-2.16l2.336 1.996h8.827l11.667-9.671v-6.667z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m402.001 191.162v-2.324l-2.336-2.007h-9.002l-2.324 2.007v5l2.324 1.832h2.171v-2.336l2.336-1.996h6.667l4.66 4.332h9.002v-12.007l-4.496-4.496v11.996h-9.002z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m390.334 212.171h2.5l-4.671-4.342v2.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m369.666 212.171v-25.34l-9.167-7.664h-28.498v7.664h5.997v25.34h-5.997v7.5h28.662l9.002-7.5zm-18.169 0h-4.496v-25.34h11.338l2.324 2.007v21.491l-2.16 1.842h-7.007z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m388.163 217.664 2.336 2.172h11.502l9.002-7.84v-8.662l-9.167-7.664h-11.173l-2.324-1.832v-5l2.324-2.007h9.002l2.336 2.007v2.324h9.002v-11.996h-9.002v1.996l-2.336-1.996h-11.327l-9.167 7.664v8.839l8.991 7.664h11.502l2.336 1.996v5l-2.171 1.842h-9.496l-2.171-1.842v-2.5h-8.991v12.007h8.991v-2.172z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m402.001 273.333h-2.829v7.829h-2.007v-7.829h-2.829v-1.667h7.829v1.667zm13.169 8.004h-2.007v-7.675l-2.829 7.675h-1.831l-2.664-7.675v7.675h-2.007v-9.671h3.333l2.171 6.338 2.336-6.338h3.333v9.671h.164z"
  }));
};

CIN.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
CIN.defaultProps = {
  size: '100'
};
var _default = CIN;
exports["default"] = _default;